<template>
  <div class="color-swatches" />
</template>

<script>

/**
 * Vue: Color swatches (color-swatches)
 * -----------------------------------------------------------------------------
 * Global color swatches section.
 * - Limited interactivity section.
 *
 * @param {Object} swatches - Global swatches object.
 *
 */
import { mapActions } from 'vuex'

export default {
  name: 'ColorSwatches',

  props: {
    swatches: {
      type: Array,
      default: () => [],
    },
  },

  mounted() {
    this.saveSwatches(this.swatches)
  },

  methods: {

    /**
     * Map Vuex actions.
     */
    ...mapActions({
      saveSwatches: 'saveSwatches',
    }),

  },
}
</script>
